import { Typography } from '@arionbanki/arionui';
import { AppContext } from 'providers/AppContext';
import { Fragment, useContext } from 'react';
import { Languages } from 'store/state';
import type { RiskChoice, RiskQLabels } from 'types';

export function Caption({ caption, language1Caption }: Readonly<RiskQLabels>) {
	const { state } = useContext(AppContext);
	const { language } = state.language;
	return <>{QuestionLabel(language, caption, language1Caption)}</>;
}

export function Choice({ caption, id, language1Caption }: Readonly<RiskChoice>) {
	const { state } = useContext(AppContext);
	const { language } = state.language;
	return <Fragment key={id}>{QuestionLabel(language, caption, language1Caption)}</Fragment>;
}

export function Description({ description, language1Description }: Readonly<RiskQLabels>) {
	const { state } = useContext(AppContext);
	const { language } = state.language;
	return <Typography TagName="p">{QuestionLabel(language, description, language1Description)}</Typography>;
}

export function QuestionLabel(language: Languages, IS_Text: string, EN_Text: string | null) {
	const text = Languages.IS === language ? IS_Text : EN_Text;
	return text ?? IS_Text;
}
